// The private chat has no Figma frame, so - like the notifications inbox it sits beside - it is put
// together from the redesign's own pieces: the tournament sheet's red panel and gold rim, a sunken
// list in the leaderboard's style, and the inbox's gold-rimmed unread rows. Numbers are in the
// 390-wide mobile design space and scaled once by each component.
import {
	PANEL_FILL,
	PANEL_RIM,
	ROW_FILL,
	TOURNAMENT_FONT,
	tournamentColors,
} from '../Tournaments/tournamentModalTheme';

export const CHAT_FONT = TOURNAMENT_FONT;
export const chatColors = {
	...tournamentColors,
	/** The inbox's list hairline, "border/red". */
	listRim: '#6B1A10',
	/** The inbox's unread dot. */
	unread: '#FF3B2F',
	/** Our own bubbles: the inbox's invite pill under the gold button rim. */
	mineFill: '#4D1A08',
	/** Their bubbles: the sunken row plate under the subtle border. */
	theirsFill: '#1F0503',
	failed: '#FF6B5E',
} as const;

export const CHAT_PANEL_FILL = PANEL_FILL;
export const CHAT_PANEL_RIM = PANEL_RIM;
export const CHAT_LIST_FILL = ROW_FILL;
/** Unread rows: the inbox's red ramp under a gold rim. */
export const CHAT_UNREAD_FILL: Array<[string, string]> = [
	['0', '#5A0B03'],
	['1', '#1F0402'],
];

/** The inbox's panel: 600 tall, 10 radius, 12/20 padding, 16 between title and list. */
export const CHAT_PANEL = { height: 600, radius: 10, paddingX: 12, paddingY: 20, gap: 12 };
